export default __webpack_public_path__ + "static/media/rightDarkArrow.c6867cd6.svg";